import { styled } from 'dripsy';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { StripeElementsOptions } from '@stripe/stripe-js';

import { ModalView } from '../components/ModalView';
import { BaseText } from '../../common/BaseText';
import { ButtonStyleEnum } from '../../common/Button';
import { StripeElementsProvider } from '@context';
import { AddCreditCardForm } from './AddCreditCardForm';
import { ScrollView } from '../../common/ScrollView';
import { Separator } from '../../common/Separator';
import { PAYMENT_METHOD_TYPES } from '@constants';

const ModalViewContainer = styled(ModalView)({
  py: '$8',
  px: '$8',
  width: 400,
  maxHeight: Platform.select<string | number>({
    web: '80vh',
    default: 600,
  }),
});

const Title = styled(BaseText)({
  variant: 'text.xlarge',
  pb: '$5',
});

const Subtitle = styled(BaseText)({
  variant: 'text.medium',
  color: '$text400',
  pb: '$6',
});

export type ConfirmationModalButtonType = {
  text: string;
  style?: ButtonStyleEnum;
};

export interface IAddCreditCardModalParams {
  onAdd(): Promise<void>;
}

export function AddCreditCardModal() {
  const { t } = useTranslation();

  const elementOptions = useMemo<StripeElementsOptions>(() => {
    return {
      mode: 'setup',
      paymentMethodTypes: PAYMENT_METHOD_TYPES,
    };
  }, []);

  return (
    <ModalViewContainer>
      <Title>{t('creditCards.addNewCard')}</Title>
      <Subtitle>{t('creditCards.addNewCardDescription')}</Subtitle>

      <ScrollView showsVerticalScrollIndicator={false}>
        <StripeElementsProvider options={elementOptions}>
          <AddCreditCardForm />
        </StripeElementsProvider>
        <Separator size="$1" />
      </ScrollView>
    </ModalViewContainer>
  );
}
